export { serializePlainText, serializePlainTextValues } from './serialize-template';
